import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectActiveMeetingChatSessionId } from 'flow/selectors/meeting-selectors';
import { selectMemberInChat } from 'flow/selectors/chat-selectors';
import { ChatSessionKey } from 'flow/types/EntityKeys';
import VideoChatSession from './VideoChatSession';
import VideoChatEphemeral from './VideoChatEphemeral';

/**
 * The chat panel's content card, framed by the shared MeetingRightPanel slot.
 * Members of the meeting's chat-service session get the full VideoChatSession;
 * everyone else (e.g. guests) gets the ephemeral relay chat.
 */
const MeetingChatPanel = () => {
    const chatSessionIdRaw = useAppSelector(selectActiveMeetingChatSessionId);
    const memberInChat = useAppSelector((state) =>
        selectMemberInChat(state, chatSessionIdRaw),
    );

    const chatSessionId = 'chatsession-'.concat(
        chatSessionIdRaw,
    ) as ChatSessionKey;

    return (
        <div className="flex min-h-0 flex-1 overflow-hidden rounded-xl bg-gray-800">
            {memberInChat ? (
                <VideoChatSession chatSessionKey={chatSessionId} />
            ) : (
                <VideoChatEphemeral />
            )}
        </div>
    );
};

export default MeetingChatPanel;
